import { fork } from 'redux-saga/effects';

import Orders from '../modules/Executorship/Order/redux/sagas';
import Requests from '../modules/Executorship/Request/redux/sagas';
import Vehicles from '../modules/Transport/redux/sagas';
import Employees from '../modules/Employees/redux/sagas';
import Customers from '../modules/Customers/redux/sagas';
import Filters from '../common/redux/sagas';
import SystemSettings from '../modules/SystemSettings/redux/sagas';
import Templates from '../modules/Templates/redux/sagas';
import Executors from '../modules/Executors/redux/sagas';
import Lists from '../modules/Lists/redux/sagas'

import {
  addProfileWatcher,
  codeWatcher,
  dadataWatcher,
  loginWatcher,
  profileListWatcher,
  restoreLoginWatcher,
  tariffWatcher,
} from '../modules/Authorization/redux/sagas';

import Offers from '../modules/Executorship/Offer/redux/sagas';
import Document from '../modules/Document/indexSaga';
import { activeProfileWatcher } from '../modules/Authorization/redux/sagas/CheckActiveProfile';
import { editProfileWatcher } from '../modules/Authorization/redux/sagas/EditProfile';
import { userWatcher } from '../modules/Authorization/redux/sagas/User/userSage';
import ControlPanelSaga from '../modules/ControlPanel/redux/sagas';

export default function*() {
  yield fork(addProfileWatcher);
  yield fork(codeWatcher);
  yield fork(dadataWatcher);
  yield fork(loginWatcher);
  yield fork(profileListWatcher);
  yield fork(restoreLoginWatcher);
  yield fork(Orders);
  yield fork(Requests);
  yield fork(Filters);
  yield fork(Vehicles);
  yield fork(Offers);
  yield fork(Employees);
  yield fork(dadataWatcher);
  yield fork(activeProfileWatcher);
  yield fork(editProfileWatcher);
  yield fork(ControlPanelSaga);
  yield fork(Customers);
  yield fork(tariffWatcher);
  yield fork(Document);
  yield fork(SystemSettings);
  yield fork(Templates);
  yield fork(Executors);
  yield fork(userWatcher);
  yield fork(Lists);
}
